"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlignment = getAlignment;
var _styledComponents = require("styled-components");
function getAlignment(alignment) {
  var justify;
  var align;
  switch (alignment) {
    case 'left':
    case 'start':
      justify = 'flex-start';
      align = 'start';
      break;
    case 'center':
      justify = 'center';
      align = 'center';
      break;
    case 'right':
    case 'end':
      justify = 'flex-end';
      align = 'end';
      break;
    default:
      return null;
  }
  return (0, _styledComponents.css)(["justify-content:", ";text-align:", ";"], justify, align);
}
//# sourceMappingURL=alignment.utils.js.map